exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-05838f2d] .ant-modal-body {\n  padding: 10px 24px;\n}\n", ""]);

// exports
